import { createContext, useContext, useState, type ReactNode } from 'react';

interface ActiveChildContextType {
    activeChildId: string | null;
    setActiveChild: (childId: string | null) => void;
    clearActiveChild: () => void;
}

const ActiveChildContext = createContext<ActiveChildContextType | undefined>(undefined);

export function ActiveChildProvider({ children }: { children: ReactNode }) {
    const [activeChildId, setActiveChildId] = useState<string | null>(null);

    const setActiveChild = (childId: string | null) => {
        setActiveChildId(childId);
    };

    const clearActiveChild = () => {
        setActiveChildId(null);
    };

    return (
        <ActiveChildContext.Provider value={{ activeChildId, setActiveChild, clearActiveChild }}>
            {children}
        </ActiveChildContext.Provider>
    );
}

export function useActiveChild() {
    const context = useContext(ActiveChildContext);
    if (context === undefined) {
        throw new Error('useActiveChild must be used within an ActiveChildProvider');
    }
    return context;
}
